<template>
  <div>
    <v-card>
      <v-card-title class="pl-8 pb-0">{{ title }}</v-card-title>

      <v-card-text>
        <v-list>
          <v-subheader class="height-fit">{{ subTitle1 }}</v-subheader>
          <v-subheader class="height-fit pb-2">{{ subTitle2 }}</v-subheader>
          <template v-for="(module, index) in sortedModules">
            <!--            <v-divider :key="`${index}_${module.id}`"></v-divider>-->
            <el-module-item :module="module" :key="`${module.id}_${index}`" @onStartExam="$emit('onStartExam', module)"></el-module-item>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ElModuleItem from './ElearningModuleItem';

export default {
  name: 'ElModuleList',
  components: {
    ElModuleItem,
  },
  props: {
    modules: Array,
    title: String,
    subTitle1: String,
    subTitle2: String,
  },

  computed: {
    sortedModules() {
      return this.modules.slice().sort((a, b) => a.sort - b.sort);
    },
  },
  methods: {
    onRequestExamStart(module) {
      console.debug('onRequestExamStart', JSON.stringify(module, null, 2));
      this.isConfirmExamStartIsOpen = true;
    },
  },
};
</script>

<style>
.height-fit {
  height: fit-content;
}
</style>
